export const WEB_ACTION_INTEREST_DIALOG_URL = 'web.action.interestDialog.url';
export const INTEREST_SELECTOR_SUBMIT_BUTTON_LABEL_TRANSLATION_KEY =
  'interest.selection.submit.button.label.translation.key';
